import { AxiosError } from 'axios';
import { useContext, useContextSelector } from 'use-context-selector';
import { APIGatewayResponse } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/types';
import { Payroll, PayrollDetails } from '../../domain/Payroll/entities/types';
import { PayrollContext } from './PayrollContext';

const usePayrollState = () => {
  const context = useContext(PayrollContext);

  if (context === undefined) {
    throw new Error('usePayrollState must be used within PayrollFileProvider');
  }

  return context;
};

const usePayrollList = () => {
  const context = useContextSelector(PayrollContext, state => state.payrollListData ?? []);

  if (context === undefined) {
    throw new Error('usePayrollList must be used within PayrollFileProvider');
  }

  return context;
};

const usePayrollDetails = () => {
  const context = useContextSelector(PayrollContext, state => state.payrollDetailsData || ({} as any));

  if (context === undefined) {
    throw new Error('usePayrollDetails must be used within PayrollFileProvider');
  }

  return context;
};

const useSelectedPayroll = () => {
  const context = useContextSelector(PayrollContext, state => state.selectedPayroll);

  if (context === undefined) {
    throw new Error('useSelectedPayroll must be used within PayrollFileProvider');
  }

  return context;
};

const usePayrollLoadingState = (loadingProperty: 'isLoadingPayrollListData' | 'isLoadingPayrollDetails') => {
  const context = useContextSelector(PayrollContext, state => state.loadingState);

  if (context === undefined) {
    throw new Error('usePayrollLoadingState must be used within PayrollFileProvider');
  }

  return context[loadingProperty];
};

const usePayrollErrorState = (
  errorProperty: 'payrollListDataError' | 'payrollDetailsError',
): AxiosError<APIGatewayResponse<Payroll[] | PayrollDetails[] | any>, any> | undefined => {
  const context = useContextSelector(PayrollContext, state => state.errorState);

  if (context === undefined) {
    throw new Error('usePayrollErrorState must be used within PayrollFileProvider');
  }

  return context[errorProperty];
};

const useOnSelectPayroll = () => {
  const context = useContextSelector(PayrollContext, state => state.onSelectPayroll);

  if (context === undefined) {
    throw new Error('useOnSelectPayroll must be used within PayrollFileProvider');
  }

  return context;
};

const useOnResetSelectedPayroll = () => {
  const context = useContextSelector(PayrollContext, state => state.onResetSelectedPayroll);

  if (context === undefined) {
    throw new Error('useOnResetSelectedPayroll must be used within PayrollFileProvider');
  }

  return context;
};

export {
  usePayrollState,
  usePayrollList,
  usePayrollDetails,
  useSelectedPayroll,
  usePayrollLoadingState,
  usePayrollErrorState,
  useOnSelectPayroll,
  useOnResetSelectedPayroll,
};
